<rt-button
  class="trigger"
  [class.trigger--expanded]="expanded()"
  variant="plain"
  size="small"
  (click)="toggle()"
>
  @if (runState() === 'running') {
    <tellent-assistant-brand-mark class="brand" [size]="18" />
  }
  <span class="label" [class.label--shimmer]="runState() === 'running'">
    @if (triggerLabelToolName(); as toolName) {
      {{ toolName }}…
    } @else if (triggerLabelKey(); as key) {
      {{ key | translate: { count: toolCount() } }}
    }
  </span>
  @if (hasContent()) {
    <rt-icon class="chev" name="expand-more" />
  }
</rt-button>

@if (expanded() && hasContent()) {
  <div class="timeline">
    @for (row of rows(); track row.key) {
      @switch (row.kind) {
        @case ('reasoning') {
          <tellent-assistant-text-part
            class="reasoning"
            [content]="row.content"
            [done]="row.done"
          />
        }
        @case ('tool-group') {
          <div
            class="row"
            [class.row--running]="row.status === 'running'"
            [class.row--error]="row.status === 'error'"
          >
            @switch (row.status) {
              @case ('done') {
                <rt-icon
                  class="ico ok"
                  name="check"
                  size="small"
                  colorToken="colorGradientAiStrongDefault"
                />
              }
              @case ('running') {
                <rt-spinner class="ico spin" variant="small-xx" />
              }
              @case ('error') {
                <rt-icon class="ico err" name="close" size="small" />
              }
            }
            @if (row.title; as title) {
              <span class="name"
                >{{ title }}
                @if (row.status === 'running') {
                  …
                }
              </span>
            } @else {
              <span class="name">{{
                'tlc.tellent_assistant.tool_call.working_status' | translate
              }}</span>
            }
            @if (row.count > 1) {
              <span class="count">×{{ row.count }}</span>
            }
          </div>
        }
      }
    }
    @if (showThinkingShimmer()) {
      <div class="row row--thinking">
        <rt-spinner class="ico spin" variant="small-xx" />
        <span class="name label">{{
          'tlc.tellent_assistant.tool_call.thinking_status' | translate
        }}</span>
      </div>
    }
  </div>
}
